import { render } from "./CreatorModalSide.vue?vue&type=template&id=1b49d795"
import script from "./CreatorModalSide.vue?vue&type=script&lang=js"
export * from "./CreatorModalSide.vue?vue&type=script&lang=js"

import "./CreatorModalSide.vue?vue&type=style&index=0&id=1b49d795&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__